export default __webpack_public_path__ + "static/media/G0250.Medical_Emergencies_in_Adults_1.1657620600000.809abf0f.jpg";